var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row vehicle-detail"},[_c('div',{staticClass:"col-lg-4 vehicle-detail-label"},[_vm._v(_vm._s(_vm.label)+":")]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 vehicle-detail-value"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }